import React, { useCallback, useEffect, useState } from "react";
import notification from "../../assets/notifications/notification.svg";
import closeIcon from "../../assets/sideBar/menu.svg";
import submit from "../../assets/notifications/submit.svg";
import arrowRight from "../../assets/scoreBoard/right-arrow.svg";

const Notifications = () => {
  const [isOpen, setIsOpen] = useState(false);

  const closePanel = useCallback(() => setIsOpen(false), []);
  const openPanel = useCallback(() => setIsOpen(true), []);
  const [replyingTo, setReplyingTo] = useState(null);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        closePanel();
      }
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [closePanel]);

  return (
    <div>
      {/* Notification trigger */}
      <button
        type="button"
        aria-label="Open notifications"
        onClick={openPanel}
        className="p-3 bg-black-0 border-2 border-black-50 rounded-bl-2xl w-[48px] h-[80px] absolute right-0 top-28 flex items-center cursor-pointer focus:outline-none focus:ring-2 focus:ring-secondary-500 z-40"
      >
        <span className="w-[30px] h-[30px] rounded-full bg-secondary-500 mr-2 absolute top-[-15px] left-[-15px] flex items-center justify-center text-xs font-bold">
          2
        </span>
        <img src={notification} alt="notification" />
      </button>

      {/* Overlay */}
      {isOpen && <div className="fixed inset-0 z-40" onClick={closePanel} />}

      {/* Slide-in panel */}
      <aside
        role="dialog"
        aria-modal="true"
        aria-label="Notifications"
        className={`fixed top-20 right-0 h-auto w-[520px] bg-gradient-01 border border-black-50 rounded-tl-2xl rounded-bl-2xl shadow-xl z-50 transition-transform duration-300 ease-out overflow-y-auto ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="h-full flex flex-col">
          {/* Header */}
          <div className="px-5 pt-5">
            <button
              type="button"
              onClick={closePanel}
              aria-label="Close notifications"
              className="p-2 mb-9"
            >
              <img src={closeIcon} alt="close" className="w-6 h-5" />
            </button>
            <div className="flex items-center">
              <span className="text-lg font-bold text-black-800">
                Leave a note to the team
              </span>
            </div>
          </div>

          {/* Input area */}
          <div className="px-5 pb-4">
            <label htmlFor="team-note" className="sr-only">
              Note input
            </label>
            <div className="flex items-center gap-3">
              <input
                id="team-note"
                type="text"
                placeholder="Placeholder"
                className="flex-1 h-11 px-3 rounded text-black-600 placeholder:text-black-50 border border-black-600 bg-black-0 focus:outline-none focus:ring-2 focus:ring-primary-400"
              />
              <button
                className="px-4 py-2 bg-secondary-400 hover:bg-secondary-500 border border-secondary-400 focus:border-primary-400 active:bg-secondary-600 text-black-900 rounded text-lg font-bold transition-colors duration-200 flex items-center justify-center gap-2"
                type="button"
              >
                <span>Submit</span>
                <img
                  src={submit}
                  alt="submit"
                />
              </button>
            </div>
            <p className="text-sm text-black-100 mt-2">
              Leave your note to connect with your team
            </p>
          </div>

          {/* Notes list */}
          <div className="flex-1 overflow-y-auto px-5 py-4">
            <p className="text-lg font-bold text-black-800 mb-2">All notes</p>
            <p className="text-lg text-black-600 mb-2">
              Here you can read all the previous notes from the team
            </p>

            {/* Example notes to match the appearance in the mock */}
            {[1, 2].map((idx) => (
              <div key={idx} className="mb-4 w-[448px]">
                {/* Comment Header */}
                <div className="flex items-center gap-2 mb-2">
                  <span className="w-6 h-6 rounded-full bg-black-40" />
                  <span className="font-bold text-black-800">
                    Colleague Name
                  </span>
                  <span className="ml-auto text-xs text-black-400">1h</span>
                  <span className="w-3 h-3 rounded-full bg-secondary-500" />
                </div>

                {/* Comment Text */}
                <input
                  readOnly
                  value="Example of colleague’s comment"
                  className="w-[416px] h-11 px-3 ml-8 rounded-lg border-2 border-black-40 hover:border-primary-400 bg-black-0 text-black-400"
                />

                {/* Actions */}
                <div className="flex items-center justify-end gap-6 text-lg text-black-600 mt-2">
                  <button type="button" className="hover:underline">
                    Solved
                  </button>
                  <button
                    type="button"
                    className="hover:underline"
                    onClick={() =>
                      setReplyingTo(replyingTo === idx ? null : idx)
                    }
                  >
                    Reply
                  </button>
                </div>

                {/* Reply Box (only show if this comment is active) */}
                {replyingTo === idx && (
                  <div className="flex items-center gap-3 mt-3 ml-8">
                    <input
                      id={`team-note-${idx}`}
                      type="text"
                      placeholder="Placeholder"
                      className="flex-1 h-11 px-3 rounded text-black-600 placeholder:text-black-50 border border-black-600 bg-black-0 focus:outline-none focus:ring-2 focus:ring-primary-400"
                    />
                    <button
                      className="px-4 py-2 bg-secondary-400 hover:bg-secondary-500 border border-secondary-400 focus:border-primary-400 active:bg-secondary-600 text-black-900 rounded text-lg font-bold transition-colors duration-200 flex items-center justify-center gap-2"
                      type="button"
                    >
                      <span>Submit</span>
                      <img
                        src={submit}
                        alt="submit"
                      />
                    </button>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </aside>
    </div>
  );
};

export default Notifications;
